import { useState, useCallback, useEffect, useRef } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Switch,
  FormControlLabel,
  Divider,
  Chip,
  IconButton,
  Paper,
  Grid,
  Avatar,
  CircularProgress,
  InputAdornment,
  Collapse,
  Fade,
  Card,
  CardContent,
  LinearProgress,
} from "@material-ui/core";
import { makeStyles, withStyles,useTheme } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import {
  Business,
  Person,
  AccountBalance,
  Home,
  Contacts,
  CloudUpload,
  Add,
  Delete,
  Check,
  ArrowForward,
  ArrowBack,
  VisibilityOff,
  VerifiedUser,
  Receipt,
  Phone,
  Email,
  AssignmentInd,
  Info,
  CheckCircle,
  Save,
  Restore,
  Close,
  Build,
  Description
} from "@material-ui/icons";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import HttpService from "../../services/httpService";
import ServiceProviderOnboarding from "./Serviceprovideronboarding";

// ─── Design tokens ────────────────────────────────────────────────────────────
const PRIMARY         = "#1A3C6E";
const PRIMARY_LIGHT   = "#2E75B6";
const PRIMARY_LIGHTER = "#EBF3FB";
const SUCCESS_COLOR   = "#1B8A5A";
const WARN_COLOR      = "#B45309";
const WARN_BG         = "#FFFBEB";
const WARN_BORDER     = "#FCD34D";
const BORDER          = "#C8D8EC";
const BG_PAGE         = "#F4F7FC";

// ─── Styled StepConnector ─────────────────────────────────────────────────────
const ECConnector = withStyles({
  alternativeLabel: { top: 22 },
  active:    { "& $line": { backgroundColor: PRIMARY_LIGHT } },
  completed: { "& $line": { backgroundColor: PRIMARY } },
  line: { height: 3, border: 0, borderRadius: 2, backgroundColor: "#E0E7F0" },
})(StepConnector);

// ─── makeStyles ───────────────────────────────────────────────────────────────
const useStyles = makeStyles((theme) => ({
  pageWrap: {
    backgroundColor: BG_PAGE,
    minHeight: "100vh",
    padding: theme.spacing(4, 0),
    [theme.breakpoints.down("xs")]: { padding: theme.spacing(2, 0) },
  },
  inner: {
    maxWidth: 780,
    margin: "0 auto",
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down("xs")]: { padding: theme.spacing(0, 1.5) },
  },

  // ── Header ──
  headerWrap:   { marginBottom: theme.spacing(3) },
  headerRow:    { display: "flex", alignItems: "center", gap: theme.spacing(1.5), marginBottom: 4 },
  headerAvatar: { backgroundColor: PRIMARY, width: 36, height: 36 },
  headerTitle:  { fontWeight: 700, color: PRIMARY },
  headerSub:    { paddingLeft: theme.spacing(7), color: theme.palette.text.secondary },

  // ── Progress ──
  progressWrap:   { marginBottom: theme.spacing(1) },
  progressTopRow: { display: "flex", justifyContent: "space-between", marginBottom: 4 },
  progressBar: {
    height: 5, borderRadius: 3, backgroundColor: "#E0E7F0",
    "& .MuiLinearProgress-bar": { backgroundColor: PRIMARY_LIGHT, borderRadius: 3 },
  },

  // ── Stepper ──
  stepperScroll:      { overflowX: "auto", paddingBottom: theme.spacing(1) },
  stepper:            { minWidth: 560, paddingTop: theme.spacing(2), paddingBottom: theme.spacing(1) },
  stepLabelActive:    { color: `${PRIMARY} !important`, fontWeight: "600 !important" },
  stepLabelCompleted: { color: `${theme.palette.text.secondary} !important` },

  // ── Step icon ──
  stepIconRoot: {
    width: 44, height: 44, display: "flex", borderRadius: "50%",
    justifyContent: "center", alignItems: "center",
    fontSize: 18, fontWeight: 600, transition: "all 0.3s ease",
  },
  stepIconDefault:   { backgroundColor: "#E0E7F0", color: "#7A95B5" },
  stepIconActive:    { backgroundColor: PRIMARY_LIGHT, color: "#fff", boxShadow: "0 0 0 6px rgba(46,117,182,0.15)" },
  stepIconCompleted: { backgroundColor: PRIMARY, color: "#fff" },

  // ── Step card ──
  stepCard: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3.5),
    borderRadius: 12,
    border: `1px solid ${BORDER}`,
    backgroundColor: "#fff",
    minHeight: 400,
    [theme.breakpoints.down("xs")]: { padding: theme.spacing(2.5) },
  },
  cardTopBand: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    marginBottom: theme.spacing(3), paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${BORDER}`,
  },
  stepOverline: {
    color: PRIMARY_LIGHT, letterSpacing: 1.5, fontSize: 11,
    textTransform: "uppercase", display: "block",
  },
  stepTitle: { fontWeight: 700, color: PRIMARY, lineHeight: 1.2 },

  // ── Section label ──
  sectionLabelWrap:   { display: "flex", alignItems: "center", gap: theme.spacing(1.5), marginBottom: theme.spacing(3) },
  sectionLabelAvatar: { backgroundColor: PRIMARY_LIGHTER, color: PRIMARY, width: 40, height: 40 },
  sectionTitle:       { fontWeight: 600, color: PRIMARY, lineHeight: 1.2 },

  // ── Navigation ──
  navRow: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    marginTop: theme.spacing(2.5), paddingLeft: 4, paddingRight: 4,
  },
  navLeft:  { display: "flex", alignItems: "center", gap: theme.spacing(1) },
  navRight: { display: "flex", alignItems: "center", gap: theme.spacing(1) },
  backBtn: {
    borderColor: BORDER, color: PRIMARY, borderRadius: 10,
    textTransform: "none", fontWeight: 600, padding: theme.spacing(0.75, 2.5),
    "&:disabled": { opacity: 0.4 },
  },
  nextBtn: {
    borderColor: BORDER, color: PRIMARY, borderRadius: 10,
    textTransform: "none", fontWeight: 600, padding: theme.spacing(0.75, 2.5),
    "&:disabled": { opacity: 0.4 },
  },
  saveDraftBtn: {
    borderColor: WARN_BORDER,
    color: WARN_COLOR,
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    padding: theme.spacing(0.75, 2),
    backgroundColor: WARN_BG,
    "&:hover": { backgroundColor: "#FEF3C7", borderColor: WARN_BORDER },
    "&:disabled": { opacity: 0.5 },
  },
  submitBtn: {
    backgroundColor: SUCCESS_COLOR, borderRadius: 10, textTransform: "none",
    fontWeight: 600, padding: theme.spacing(0.75, 3), boxShadow: "none",
    "&:hover": { backgroundColor: SUCCESS_COLOR, filter: "brightness(0.92)", boxShadow: "none" },
  },

  // ── Draft resume banner ──
  draftBanner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 2),
    borderRadius: 10,
    backgroundColor: WARN_BG,
    border: `1px solid ${WARN_BORDER}`,
    marginBottom: theme.spacing(2.5),
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  draftBannerLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  draftBannerIcon: {
    color: WARN_COLOR,
    fontSize: 22,
  },
  draftBannerActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  resumeBtn: {
    backgroundColor: WARN_COLOR,
    color: "#fff",
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    padding: theme.spacing(0.5, 2),
    boxShadow: "none",
    "&:hover": { backgroundColor: "#92400E", boxShadow: "none" },
  },
  discardBtn: {
    borderColor: WARN_BORDER,
    color: WARN_COLOR,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    padding: theme.spacing(0.5, 1.5),
  },

  // ── Dot pagination ──
  dotRow: { display: "flex", gap: 4, alignItems: "center" },
  dot:    { height: 8, borderRadius: 4, transition: "all 0.3s ease" },

  // ── Toggle boxes ──
  toggleBox: {
    padding: theme.spacing(2), borderRadius: 8,
    border: `1px solid ${BORDER}`, marginBottom: theme.spacing(2),
  },

  // ── Rent terms box ──
  rentTermsBox: {
    padding: theme.spacing(2.5), borderRadius: 8,
    backgroundColor: "rgba(235,243,251,0.6)",
    border: `1px solid ${BORDER}`, marginBottom: theme.spacing(2),
  },
  rentPreview: {
    marginTop: theme.spacing(2), padding: theme.spacing(1.5),
    backgroundColor: "#fff", borderRadius: 6, border: `1px solid ${BORDER}`,
    display: "flex", alignItems: "center", gap: theme.spacing(1),
  },

  // ── File upload card ──
  fileCard: {
    border: `1.5px dashed ${BORDER}`, borderRadius: 8, padding: theme.spacing(2),
    cursor: "pointer", transition: "all 0.2s", display: "flex",
    alignItems: "center", gap: theme.spacing(1.5), minHeight: 64,
    "&:hover": { borderColor: PRIMARY_LIGHT, backgroundColor: PRIMARY_LIGHTER },
  },
  fileCardUploaded: { borderColor: PRIMARY_LIGHT, backgroundColor: "rgba(235,243,251,0.6)" },
  fileAvatar:         { width: 36, height: 36 },
  fileAvatarUploaded: { backgroundColor: "rgba(26,60,110,0.12)", color: PRIMARY },
  fileAvatarEmpty:    { backgroundColor: "rgba(46,117,182,0.08)", color: PRIMARY_LIGHT },

  // ── Upload summary ──
  uploadSummary: {
    marginTop: theme.spacing(3), padding: theme.spacing(2),
    backgroundColor: "rgba(235,243,251,0.5)", borderRadius: 8,
  },
  summaryLabel: {
    color: theme.palette.text.secondary, fontWeight: 600, fontSize: 11,
    letterSpacing: 1, textTransform: "uppercase", display: "block",
    marginBottom: theme.spacing(1),
  },
  chipUploaded: {
    backgroundColor: "rgba(27,138,90,0.1)", color: SUCCESS_COLOR,
    border: "1px solid rgba(27,138,90,0.3)", fontWeight: 600, marginRight: 4, marginBottom: 4,
  },
  chipPending: {
    backgroundColor: "#F5F5F5", color: theme.palette.text.secondary,
    border: `1px solid ${BORDER}`, marginRight: 4, marginBottom: 4,
  },
  chipOther: {
    backgroundColor: "rgba(46,117,182,0.1)", color: PRIMARY_LIGHT,
    border: "1px solid rgba(46,117,182,0.3)", marginRight: 4, marginBottom: 4,
  },

  // ── Contact person card ──
  contactCard:       { marginBottom: theme.spacing(2), borderRadius: 8 },
  contactCardHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: theme.spacing(2) },
  contactNumAvatar:  { width: 28, height: 28, fontSize: 13, fontWeight: 700 },

  // ── Success screen ──
  successWrap: {
    maxWidth: 560, margin: "0 auto", marginTop: theme.spacing(6),
    padding: theme.spacing(0, 2), textAlign: "center",
  },
  successAvatar: {
    width: 72, height: 72, backgroundColor: "rgba(27,138,90,0.1)",
    color: SUCCESS_COLOR, margin: "0 auto", marginBottom: theme.spacing(3),
  },
  summaryPaper: {
    padding: theme.spacing(2.5), borderRadius: 8,
    border: `1px solid ${BORDER}`, textAlign: "left", marginBottom: theme.spacing(3),
  },
  summaryRow: {
    display: "flex", justifyContent: "space-between", padding: theme.spacing(0.75, 0),
    borderBottom: `0.5px solid ${BORDER}`,
    "&:last-child": { borderBottom: "none" },
  },
  outlinedBtn: { borderColor: BORDER, color: PRIMARY_LIGHT, borderRadius: 8, textTransform: "none" },
  primaryBtn:  {
    backgroundColor: PRIMARY, borderRadius: 8, textTransform: "none", boxShadow: "none",
    "&:hover": { backgroundColor: PRIMARY_LIGHT, boxShadow: "none" },
  },
  addBtn:    { color: PRIMARY_LIGHT, textTransform: "none" },
  addDocBtn: { borderColor: BORDER, color: PRIMARY, borderRadius: 8, textTransform: "none" },
  otherDocRow: {
    display: "flex", alignItems: "center", gap: theme.spacing(1.5),
    padding: theme.spacing(1.5), border: `1px solid ${BORDER}`, borderRadius: 6,
    marginBottom: theme.spacing(1), backgroundColor: "rgba(235,243,251,0.4)",
  },
  infoAlert:       { borderRadius: 8, fontSize: 13, marginBottom: theme.spacing(2.5) },

  // ── Mandatory contact badge ──
  mandatoryBadgeChip: {
    backgroundColor: "rgba(26,60,110,0.08)",
    color: PRIMARY,
    border: `1px solid ${BORDER}`,
    fontWeight: 600,
    fontSize: 11,
    marginBottom: theme.spacing(1.5),
  },

  // ── Onboarding type selector ──
  typeSelectorWrap: {
    marginBottom: theme.spacing(3),
  },
  typeSelectorLabel: {
    fontWeight: 600,
    color: PRIMARY,
    fontSize: 12,
    letterSpacing: 1,
    textTransform: "uppercase",
    marginBottom: theme.spacing(1),
    display: "block",
  },
  typeToggleRow: {
    display: "flex",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  typeToggleBtn: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 2.5),
    borderRadius: 10,
    border: `1.5px solid ${BORDER}`,
    cursor: "pointer",
    transition: "all 0.2s",
    backgroundColor: "#fff",
    "&:hover": { borderColor: PRIMARY_LIGHT, backgroundColor: PRIMARY_LIGHTER },
  },
  typeToggleBtnActive: {
    borderColor: PRIMARY_LIGHT,
    backgroundColor: PRIMARY_LIGHTER,
    boxShadow: `0 0 0 3px rgba(46,117,182,0.12)`,
  },
  typeToggleIcon: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  typeToggleIconActive: { backgroundColor: PRIMARY_LIGHT },
  typeToggleIconInactive: { backgroundColor: "#E0E7F0" },
}));

// ─── Constants ────────────────────────────────────────────────────────────────
const STEPS = [
  { label: "EC & Identity",    sub: "Basic information" },
  { label: "Tax & Compliance", sub: "PAN, GST & TDS + documents" },
  { label: "Bank Details",     sub: "Payment account + cheque" },
  { label: "Property",         sub: "Address, terms & agreement" },
  { label: "Contacts",         sub: "Contact persons & other docs" },
];

const ACCOUNT_TYPES = ["savings", "current", "nro", "nre"];

const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh",
  "Jammu & Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh",
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
  "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
];

const STEP_ICONS = [Business, AssignmentInd, AccountBalance, Home, Contacts];

// ─── Blank contact person ─────────────────────────────────────────────────────
const BLANK_CONTACT = {
  name: "", primary_mobile: "", alternate_mobile: "",
  email: "", whatsapp_number: "", note: "",
};

// ─── Initial form state ───────────────────────────────────────────────────────
const INITIAL = {
  experienceCenterId: "",
  owner_name: "",
  remarks: "",
  pan_number: "",
  rent_amount: "",
  rental_start_date: "", 
  rent_increment_period_months: "12", 
  aadhaar: "",
  gst_applicable: false,
  gst_number: "",
  gst_percentage: "",
  tds_applicable: false,
  tds_percentage: "",
  bank: {
    account_number: "", account_name: "", bank_name: "",
    branch_name: "", ifsc_code: "", account_type: "savings",
  },
  address: { line1: "", line2: "", city: "", state: "", pincode: "" },
  due_day: "",
  max_payment_day: "",
  penalty_per_day: "0",
  agreement_effective_date: "",
  agreement_expiry_date: "",
  yearly_increment_type: "percentage",
  yearly_increment_value: "",
  contact_persons: [{ ...BLANK_CONTACT }],
  files: {
    aadhaar_doc: null, pan_doc: null,
    gst_doc: null, tds_doc: null,
    cheque_doc: null, agreement_doc: null,
    other_docs: [],
  },
};

// ─── Validation ───────────────────────────────────────────────────────────────
// ─── Validation ───────────────────────────────────────────────────────────────
// ─── Validation ───────────────────────────────────────────────────────────────
function validateStep(step, form, isEditMode = false) {
  const e = {};

  if (step === 0) {
    if (!form.experienceCenterId)    e.experienceCenterId = "Select an Experience Centre";
    if (!form.owner_name.trim())     e.owner_name         = "Owner name is required";
  }

  if (step === 1) {
    if (!form.pan_number.trim()) e.pan_number = "PAN is required";
    else if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(form.pan_number.toUpperCase()))
      e.pan_number = "Invalid PAN format (e.g. ABCDE1234F)";
    // Aadhaar is immutable once onboarded — not editable/re-enterable in edit mode.
    const rawAadhaar = form.aadhaar.replace(/\s/g, "");
    if (!isEditMode) {
      if (!rawAadhaar)                          e.aadhaar = "Aadhaar is required";
      else if (!/^\d{12}$/.test(rawAadhaar))    e.aadhaar = "Must be exactly 12 digits";
    } else if (rawAadhaar && !/^\d{12}$/.test(rawAadhaar)) {
      e.aadhaar = "Must be exactly 12 digits";
    }

    if (!form.files.aadhaar_doc) e.aadhaar_doc = "Aadhaar Card upload is required";
    if (!form.files.pan_doc)     e.pan_doc     = "PAN Card upload is required";

    if (form.gst_applicable) {
      if (!form.gst_number.trim()) {
        e.gst_number = "GST number required when GST is applicable";
      } else {
        // ─── GST Regex Validation ──────────────────────────────────────────────
        // GST format: 22AAAAA0000A1Z5 (15 characters)
        // 22 - State code, AAAAA - PAN, 0000 - Entity code, A - Check digit, 1 - Z, 5 - Check digit
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!gstRegex.test(form.gst_number.toUpperCase())) {
          e.gst_number = "Invalid GST format (e.g. 22AAAAA0000A1Z5)";
        }
      }
      
      if (!form.gst_percentage) {
        e.gst_percentage = "GST percentage required when GST is applicable";
      } else {
        const gstPercent = parseFloat(form.gst_percentage);
        if (isNaN(gstPercent) || gstPercent < 0 || gstPercent > 100) {
          e.gst_percentage = "GST percentage must be between 0 and 100";
        }
      }

      if (!form.files.gst_doc) e.gst_doc = "GST Certificate upload is required when GST is applicable";
    }
    
    if (form.tds_applicable) {
      if (!form.tds_percentage) {
        e.tds_percentage = "TDS percentage required when TDS is applicable";
      } else {
        const tdsPercent = parseFloat(form.tds_percentage);
        if (isNaN(tdsPercent) || tdsPercent < 0 || tdsPercent > 100) {
          e.tds_percentage = "TDS percentage must be between 0 and 100";
        }
      }
    }
  }

  if (step === 2) {
    const b = form.bank;
    if (!b.account_number) e.account_number = "Required";
    if (!b.account_name)   e.account_name   = "Required";
    if (!b.bank_name)      e.bank_name      = "Required";
    if (!b.branch_name)    e.branch_name    = "Required";
    if (!b.ifsc_code)      e.ifsc_code      = "Required";
    else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(b.ifsc_code.toUpperCase()))
      e.ifsc_code = "Invalid IFSC (e.g. SBIN0001234)";

    if (!form.files.cheque_doc) e.cheque_doc = "Cancelled cheque / passbook upload is required";
  }

  if (step === 3) {
    const a = form.address;
    if (!a.line1)   e.addr_line1   = "Street address required";
    if (!a.city)    e.addr_city    = "City required";
    if (!a.state)   e.addr_state   = "State required";
    if (!a.pincode) e.addr_pincode = "Pincode required";
    else if (!/^\d{6}$/.test(a.pincode)) e.addr_pincode = "Must be 6 digits";
    
    // ─── Rent Amount Validation ──────────────────────────────────────────────
    if (!form.rent_amount || parseFloat(form.rent_amount) <= 0) {
      e.rent_amount = "Rent amount is required and must be greater than 0";
    }
    
    if (!form.due_day)         e.due_day         = "Required";
    if (!form.max_payment_day) e.max_payment_day = "Required";
    else if (parseInt(form.max_payment_day) < parseInt(form.due_day))
      e.max_payment_day = "Must be ≥ due day";
    if (!form.penalty_per_day && form.penalty_per_day !== "0") 
      e.penalty_per_day = "Required";
    
    // ─── Agreement Date Validations ──────────────────────────────────────────
    if (!form.agreement_effective_date) {
      e.agreement_effective_date = "Agreement effective date is required";
    }
    if (!form.agreement_expiry_date) {
      e.agreement_expiry_date = "Agreement expiry date is required";
    }
    if (form.agreement_effective_date && form.agreement_expiry_date) {
      const effectiveDate = new Date(form.agreement_effective_date);
      const expiryDate = new Date(form.agreement_expiry_date);
      if (expiryDate <= effectiveDate) {
        e.agreement_expiry_date = "Expiry date must be after effective date";
      }
    }
    if (form.yearly_increment_type && form.yearly_increment_value) {
      const incrementValue = parseFloat(form.yearly_increment_value);
      if (isNaN(incrementValue) || incrementValue < 0) {
        e.yearly_increment_value = "Increment value must be a positive number";
      }
      if (form.yearly_increment_type === "percentage" && incrementValue > 100) {
        e.yearly_increment_value = "Percentage increment cannot exceed 100%";
      }
    }
    if (!form.rental_start_date) {
      e.rental_start_date = "Rental start date is required";
    }
    
    if (!form.rent_increment_period_months || parseInt(form.rent_increment_period_months) < 1) {
      e.rent_increment_period_months = "Rent increment period must be at least 1 month";
    }

    if (!form.files.agreement_doc) e.agreement_doc = "Rental agreement upload is required";
  }

  if (step === 4) {
    const first = form.contact_persons[0] || {};
    if (!first.name || !first.name.trim())
      e.cp0_name = "Name is required";
    if (!first.primary_mobile || !/^[6-9]\d{9}$/.test(first.primary_mobile))
      e.cp0_mobile = "Valid 10-digit mobile required";
    if (!first.email || !first.email.trim())
      e.cp0_email = "Email is required";
    if (!first.whatsapp_number || !/^[6-9]\d{9}$/.test(first.whatsapp_number))
      e.cp0_whatsapp = "Valid WhatsApp number required";
    form.contact_persons.slice(1).forEach((cp, i) => {
      if (cp.primary_mobile && !/^[6-9]\d{9}$/.test(cp.primary_mobile))
        e[`cp${i + 1}_mobile`] = "Invalid 10-digit mobile";
    });
  }

  return e;
}

// ─── StepIcon ─────────────────────────────────────────────────────────────────
function ECStepIcon({ active, completed, icon }) {
  const classes = useStyles();
  const Icon    = STEP_ICONS[icon - 1] || Business;
  const rootCls = [
    classes.stepIconRoot,
    completed ? classes.stepIconCompleted : active ? classes.stepIconActive : classes.stepIconDefault,
  ].join(" ");
  return (
    <div className={rootCls}>
      {completed ? <Check style={{ fontSize: 20 }} /> : <Icon style={{ fontSize: 20 }} />}
    </div>
  );
}

// ─── SectionLabel ─────────────────────────────────────────────────────────────
function SectionLabel({ icon: Icon, title, subtitle }) {
  const classes = useStyles();
  return (
    <div className={classes.sectionLabelWrap}>
      <Avatar className={classes.sectionLabelAvatar}>
        <Icon style={{ fontSize: 20 }} />
      </Avatar>
      <div>
        <Typography variant="subtitle1" className={classes.sectionTitle}>{title}</Typography>
        {subtitle && <Typography variant="caption" color="textSecondary">{subtitle}</Typography>}
      </div>
    </div>
  );
}

// ─── FileUploadCard ───────────────────────────────────────────────────────────
// ─── FileUploadCard ───────────────────────────────────────────────────────────
function FileUploadCard({ label, required, hint, error, fieldKey, file, onChange, uploading, uploadProgress }) {
  const classes = useStyles();
  const id      = `upload-${fieldKey}`;
  const done    = Boolean(file);
  return (
    <div>
      <label
        htmlFor={id}
        className={[classes.fileCard, done ? classes.fileCardUploaded : ""].join(" ")}
        style={error ? { borderColor: "#D32F2F" } : undefined}
      >
        <input
          id={id}
          type="file"
          style={{ display: "none" }}
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
          onChange={(e) => onChange(fieldKey, e.target.files[0] || null)}
          disabled={uploading}
        />
        <Avatar className={[classes.fileAvatar, done ? classes.fileAvatarUploaded : classes.fileAvatarEmpty].join(" ")}>
          {uploading ? (
            <CircularProgress size={18} style={{ color: PRIMARY_LIGHT }} />
          ) : done ? (
            <Check style={{ fontSize: 18 }} />
          ) : (
            <CloudUpload style={{ fontSize: 18 }} />
          )}
        </Avatar>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" style={{ fontWeight: 500, color: done ? PRIMARY : undefined }}>
            {label}{required && <span style={{ color: "#D32F2F", marginLeft: 2 }}>*</span>}
          </Typography>
          <Typography variant="caption" color={error ? "error" : "textSecondary"} noWrap display="block">
            {uploading
              ? `Uploading... ${Math.round(uploadProgress)}%`
              : done
                ? file.name
                : (error || hint || "PDF, JPG or PNG · max 10 MB")
            }
          </Typography>
        </div>
        {done && !uploading && (
          <IconButton
            size="small"
            onClick={(e) => { e.preventDefault(); onChange(fieldKey, null); }}
            style={{ color: "#D32F2F" }}
          >
            <Delete style={{ fontSize: 16 }} />
          </IconButton>
        )}
      </label>
      {uploading && (
        <LinearProgress
          variant="determinate"
          value={uploadProgress}
          style={{ marginTop: 4, height: 4, borderRadius: 2 }}
        />
      )}
    </div>
  );
}


// ─── ContactPersonCard ────────────────────────────────────────────────────────
function ContactPersonCard({ index, person, isMandatory, cpErrors = {}, onChange, onRemove }) {
  const classes = useStyles();
  const upd     = (key, val) => onChange(index, { ...person, [key]: val });
  const reqLabel = (lbl) => isMandatory ? `${lbl} *` : lbl;

  return (
    <Card
      className={classes.contactCard}
      variant="outlined"
      style={{
        borderColor: isMandatory ? PRIMARY_LIGHT : BORDER,
        borderWidth:  isMandatory ? 1.5 : 1,
      }}
    >
      <CardContent style={{ paddingBottom: 16 }}>
        <div className={classes.contactCardHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Avatar
              className={classes.contactNumAvatar}
              style={{
                backgroundColor: isMandatory ? PRIMARY : PRIMARY_LIGHTER,
                color:           isMandatory ? "#fff"  : PRIMARY,
              }}
            >
              {index + 1}
            </Avatar>
            <div>
              <Typography variant="subtitle2" style={{ fontWeight: 600, lineHeight: 1.2 }}>
                Contact Person {index + 1}
              </Typography>
              {isMandatory && (
                <Typography variant="caption" style={{ color: PRIMARY_LIGHT, fontSize: 10 }}>
                  PRIMARY — REQUIRED
                </Typography>
              )}
            </div>
          </div>
          {!isMandatory && (
            <IconButton size="small" onClick={() => onRemove(index)} style={{ color: "#D32F2F" }}>
              <Delete style={{ fontSize: 18 }} />
            </IconButton>
          )}
        </div>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined"
              label={reqLabel("Full Name")}
              value={person.name}
              onChange={(e) => upd("name", e.target.value)}
              error={!!cpErrors.name}
              helperText={cpErrors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined"
              label={reqLabel("Primary Mobile")}
              value={person.primary_mobile}
              onChange={(e) => upd("primary_mobile", e.target.value.replace(/\D/g, "").slice(0, 10))}
              error={!!cpErrors.primary_mobile}
              helperText={cpErrors.primary_mobile}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" color="textSecondary">+91</Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined"
              label="Alternate Mobile"
              value={person.alternate_mobile}
              onChange={(e) => upd("alternate_mobile", e.target.value.replace(/\D/g, "").slice(0, 10))}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone style={{ fontSize: 16, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined"
              label={reqLabel("Email")}
              type="email"
              value={person.email}
              onChange={(e) => upd("email", e.target.value)}
              error={!!cpErrors.email}
              helperText={cpErrors.email}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email style={{ fontSize: 16, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined"
              label={reqLabel("WhatsApp Number")}
              value={person.whatsapp_number}
              onChange={(e) => upd("whatsapp_number", e.target.value.replace(/\D/g, "").slice(0, 10))}
              error={!!cpErrors.whatsapp_number}
              helperText={cpErrors.whatsapp_number}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined"
              label="Note (optional)"
              value={person.note}
              onChange={(e) => upd("note", e.target.value)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
// Maps a RentalOwner.documents[].doc_type back to the form's files.* key, for
// pre-filling the Edit flow (docs already uploaded show as "uploaded").
const DOC_TYPE_TO_FILE_KEY = {
  aadhaar: "aadhaar_doc",
  pan: "pan_doc",
  gst_certificate: "gst_doc",
  cancelled_cheque: "cheque_doc",
  rental_agreement: "agreement_doc",
};
const FILE_KEY_TO_DOC_TYPE = {
  aadhaar_doc: "aadhaar",
  pan_doc: "pan",
  gst_doc: "gst_certificate",
  cheque_doc: "cancelled_cheque",
  agreement_doc: "rental_agreement",
};

// Builds the DocumentSchema-shaped array the update endpoint expects, from
// the form's files.* state (used for the Edit flow, which submits JSON —
// same shape the create endpoint already builds server-side from `files`).
function buildDocumentsFromFiles(files) {
  const documents = [];
  Object.entries(FILE_KEY_TO_DOC_TYPE).forEach(([fieldKey, docType]) => {
    const f = files[fieldKey];
    if (f?.s3Link) {
      documents.push({
        doc_type: docType,
        file_path: f.s3Link,
        original_name: f.name || "unknown",
        mime_type: f.type || "application/octet-stream",
        file_size_kb: Math.round((f.size || 0) / 1024),
      });
    }
  });
  (files.other_docs || []).forEach((f) => {
    if (f?.s3Link) {
      documents.push({
        doc_type: "other",
        file_path: f.s3Link,
        original_name: f.name || "unknown",
        mime_type: f.type || "application/octet-stream",
        file_size_kb: Math.round((f.size || 0) / 1024),
      });
    }
  });
  return documents;
}

const RentalOwnerOnboarding = function (props) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();

  const queryParams  = new URLSearchParams(location.search);
  const editId        = queryParams.get("editId");
  const editTypeParam = queryParams.get("editType") || "rental";
  const isEditMode     = Boolean(editId);

  const [onboardingType, setOnboardingType] = useState(isEditMode ? editTypeParam : "rental"); // "rental" | "service_provider"
  const [loadingEditRecord, setLoadingEditRecord] = useState(isEditMode && editTypeParam === "rental");

  const [step,               setStep]               = useState(0);
  const [form,               setForm]               = useState(INITIAL);
  const [errors,             setErrors]             = useState({});
  const [submitting,         setSubmitting]         = useState(false);
  const [submitted,          setSubmitted]          = useState(false);
  const [touched,            setTouched]            = useState(false);
  const [allExperienceCenters, setAllExperienceCenters] = useState([]);

  // ── Draft state ───────────────────────────────────────────────────────────
  const [existingDraft,   setExistingDraft]   = useState(null);   // draft object from API
  const [showDraftBanner, setShowDraftBanner] = useState(false);
  const [savingDraft,     setSavingDraft]     = useState(false);
  const [draftSavedAt,    setDraftSavedAt]    = useState(null);   // timestamp label

  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadError, setUploadError] = useState(null);

const setFile = (key, file) =>
    setForm((f) => ({ ...f, files: { ...f.files, [key]: file } }));
  // ── Fetch Experience Centres ──────────────────────────────────────────────
  const fetchExperienceCenters = async () => {
    try {
      props.setLoading(true);
      const res = await HttpService.getAllExperienceCenter();
      setAllExperienceCenters(res?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Failed to load Experience Centres", "error");
    } finally {
      props.setLoading(false);
    }
  };

  // ── Fetch latest draft on mount ───────────────────────────────────────────
  const fetchLatestDraft = async () => {
    try {
      const res = await HttpService.getRentalOwnerDrafts();         // GET /ex/owners/drafts
      const drafts = res?.data?.data || [];
      if (drafts.length > 0) {
        setExistingDraft(drafts[0]);   // most recent first (backend sorts by updatedAt desc)
        setShowDraftBanner(true);
      }
    } catch (_) {
      // silent — draft is a convenience feature, don't block the user
    }
  };

  // ── Load an existing owner into the form for editing ──────────────────────
  const fetchEditRecord = async () => {
    try {
      const res = await HttpService.getRentalOwner(editId);
      const o = res?.data?.data;
      if (!o) {
        props.setSnackInfo("Owner record not found", "error");
        return;
      }

      const files = { ...INITIAL.files };
      (o.documents || []).forEach((doc) => {
        const key = DOC_TYPE_TO_FILE_KEY[doc.doc_type];
        const meta = { name: doc.original_name || doc.doc_type, s3Link: doc.file_path, existing: true };
        if (key) files[key] = meta;
        else if (doc.doc_type === "other") files.other_docs = [...files.other_docs, meta];
      });

      setForm({
        experienceCenterId: o.experienceCenterId?._id || o.experienceCenterId || "",
        owner_name: o.owner_name || "",
        remarks: o.remarks || "",
        pan_number: o.pan_number || "",
        rent_amount: o.rent_amount ?? "",
        rental_start_date: o.rental_start_date ? o.rental_start_date.slice(0, 10) : "",
        rent_increment_period_months: String(o.rent_increment_period_months || 12),
        aadhaar: "", // never returned by the API — re-entry not required unless changing it
        gst_applicable: !!o.gst_applicable,
        gst_number: o.gst_number || "",
        gst_percentage: o.gst_percentage ?? "",
        tds_applicable: !!o.tds_applicable,
        tds_percentage: o.tds_percentage ?? "",
        bank: o.bank || INITIAL.bank,
        address: o.address || INITIAL.address,
        due_day: o.due_day ?? "",
        max_payment_day: o.max_payment_day ?? "",
        penalty_per_day: String(o.penalty_per_day ?? "0"),
        agreement_effective_date: o.agreement_effective_date ? o.agreement_effective_date.slice(0, 10) : "",
        agreement_expiry_date: o.agreement_expiry_date ? o.agreement_expiry_date.slice(0, 10) : "",
        yearly_increment_type: o.yearly_increment_type || "percentage",
        yearly_increment_value: o.yearly_increment_value ?? "",
        contact_persons: o.contact_persons?.length ? o.contact_persons : [{ ...BLANK_CONTACT }],
        files,
      });
    } catch (err) {
      props.setSnackInfo(err?.response?.data?.message || "Failed to load owner record", "error");
    } finally {
      setLoadingEditRecord(false);
    }
  };

  useEffect(() => {
    fetchExperienceCenters();
    if (isEditMode && editTypeParam === "rental") {
      fetchEditRecord();
    } else if (!isEditMode) {
      fetchLatestDraft();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─── File upload handler with S3 ──────────────────────────────────────────────
const handleFileUpload = useCallback(async (fieldKey, file) => {
  if (!file) {
    // Remove file
    setFile(fieldKey, null);
    return;
  }

  // Validate file size (10MB max)
  if (file.size > 10 * 1024 * 1024) {
    props.setSnackInfo(`File "${file.name}" exceeds 10MB limit`, "error");
    return;
  }

  // Validate file type
  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 
                        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  if (!allowedTypes.includes(file.type)) {
    props.setSnackInfo(`File type "${file.type}" is not supported. Please upload PDF, JPG, PNG, or DOC files.`, "error");
    return;
  }

  setUploadingFile(true);
  setUploadProgress(prev => ({ ...prev, [fieldKey]: 0 }));

  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await HttpService.uploadFile(formData);
    const s3Link = response.data?.s3Link || response.data?.url || response.data;

    // Store the file with S3 link
    setFile(fieldKey, {
      name: file.name,
      size: file.size,
      type: file.type,
      s3Link: s3Link,
      uploadedAt: new Date().toISOString(),
    });

    setUploadProgress(prev => ({ ...prev, [fieldKey]: 100 }));
    props.setSnackInfo(`File "${file.name}" uploaded successfully`, "success");

  } catch (err) {
    props.setSnackInfo(`Failed to upload "${file.name}": ${err?.message || 'Unknown error'}`, "error");
    setUploadError(err?.message || 'Upload failed');
  } finally {
    setUploadingFile(false);
  }
}, [props, setFile]);

// ─── Handle Other Documents Upload ──────────────────────────────────────────
const handleOtherDocsUpload = useCallback(async (e) => {
  const files = Array.from(e.target.files || []);
  if (files.length === 0) return;

  setUploadingFile(true);

  try {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.size > 10 * 1024 * 1024) {
        props.setSnackInfo(`File "${file.name}" exceeds 10MB limit`, "error");
        continue;
      }

      const formData = new FormData();
      formData.append("file", file);

      const response = await HttpService.uploadFile(formData);
      const s3Link = response.data?.s3Link || response.data?.url || response.data;

      setForm((f) => ({
        ...f,
        files: {
          ...f.files,
          other_docs: [
            ...f.files.other_docs,
            {
              name: file.name,
              size: file.size,
              type: file.type,
              s3Link: s3Link,
              uploadedAt: new Date().toISOString(),
            }
          ]
        }
      }));

      props.setSnackInfo(`File "${file.name}" uploaded successfully`, "success");
    }
  } catch (err) {
    props.setSnackInfo(`Failed to upload files: ${err?.message || 'Unknown error'}`, "error");
  } finally {
    setUploadingFile(false);
  }
}, []);

  // ── Resume draft: pre-fill form, dismiss banner ───────────────────────────
  const handleResumeDraft = () => {
    if (!existingDraft?.formData) return;
    // Restore all scalar fields; files cannot be restored (browser security)
    const saved = existingDraft.formData;
    setForm((prev) => ({
      ...prev,
      ...saved,
      // Ensure files sub-object stays blank (can't restore File objects)
      files: INITIAL.files,
    }));
    setStep(0);
    setShowDraftBanner(false);
    props.setSnackInfo("Draft restored — files must be re-uploaded", "info");
  };

  // ── Discard draft ─────────────────────────────────────────────────────────
  const handleDiscardDraft = async () => {
    setShowDraftBanner(false);
    if (!existingDraft?._id) return;
    try {
      await HttpService.deleteRentalOwnerDraft(existingDraft._id);  // DELETE /ex/owners/draft/:id
      setExistingDraft(null);
    } catch (_) { /* silent */ }
  };

  // ── Save draft ────────────────────────────────────────────────────────────
  const handleSaveDraft = async () => {
    setSavingDraft(true);
    try {
      // Strip File objects — they cannot be serialised to JSON
      const payload = {
        ...form,
        draft_step: step,            // remember current step for display
        files: {},                   // omit file objects
      };

      let res;
      if (existingDraft?._id) {
        // Update existing draft
        res = await HttpService.updateRentalOwnerDraft(existingDraft._id, payload);
        // PUT /ex/owners/update-draft/:id
      } else {
        // Create new draft
        res = await HttpService.createRentalOwnerDraft(payload);
        // POST /ex/owners/draft
        if (res?.data?.data?._id) {
          setExistingDraft(res.data.data);
        }
      }

      const now = new Date();
      setDraftSavedAt(
        now.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
      );
      props.setSnackInfo("Draft saved successfully", "success");
    } catch (err) {
      props.setSnackInfo(
        err?.response?.data?.message || "Failed to save draft",
        "error"
      );
    } finally {
      setSavingDraft(false);
    }
  };

  // ── Soft-delete draft after successful submission ─────────────────────────
  const deleteDraftAfterSubmit = async () => {
    if (!existingDraft?._id) return;
    try {
      await HttpService.deleteRentalOwnerDraft(existingDraft._id);
    } catch (_) { /* silent — submission already succeeded */ }
  };

  // ── Generic field updaters ────────────────────────────────────────────────
  const set = useCallback((key, val) => {
    setForm((f) => ({ ...f, [key]: val }));
    setErrors((e) => { const n = { ...e }; delete n[key]; return n; });
  }, []);

  const setBank = (key, val) => {
    setForm((f) => ({ ...f, bank: { ...f.bank, [key]: val } }));
    setErrors((e) => { const n = { ...e }; delete n[key]; return n; });
  };

  const setAddr = (key, val) => {
    setForm((f) => ({ ...f, address: { ...f.address, [key]: val } }));
    setErrors((e) => { const n = { ...e }; delete n[`addr_${key}`]; return n; });
  };

  // ── Contact persons ───────────────────────────────────────────────────────
  const addContact = () => {
    if (form.contact_persons.length < 4)
      setForm((f) => ({ ...f, contact_persons: [...f.contact_persons, { ...BLANK_CONTACT }] }));
  };
  const updContact = (i, v) => {
    const a = [...form.contact_persons]; a[i] = v;
    setForm((f) => ({ ...f, contact_persons: a }));
  };
  const remContact = (i) => {
    if (i === 0) return;
    setForm((f) => ({ ...f, contact_persons: f.contact_persons.filter((_, idx) => idx !== i) }));
  };

  // ── File handlers ─────────────────────────────────────────────────────────
  // const setFile = (key, file) =>
  //   setForm((f) => ({ ...f, files: { ...f.files, [key]: file } }));

  const addOtherFiles = (e) => {
    const incoming = Array.from(e.target.files || []);
    setForm((f) => ({
      ...f,
      files: { ...f.files, other_docs: [...f.files.other_docs, ...incoming].slice(0, 5) },
    }));
  };
  const remOtherFile = (i) =>
    setForm((f) => ({
      ...f,
      files: { ...f.files, other_docs: f.files.other_docs.filter((_, idx) => idx !== i) },
    }));

  // ── Navigation ────────────────────────────────────────────────────────────
  const handleNext = () => {
    const errs = validateStep(step, form, isEditMode);
    if (Object.keys(errs).length) { setErrors(errs); setTouched(true); return; }
    setErrors({}); setTouched(false);
    setStep((s) => s + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleBack = () => {
    setStep((s) => s - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
       const payload = {
      ...form,
      agreement_effective_date: form.agreement_effective_date || null,
      agreement_expiry_date: form.agreement_expiry_date || null,
      yearly_increment_type: form.yearly_increment_type || null,
      yearly_increment_value: form.yearly_increment_value ? parseFloat(form.yearly_increment_value) : null,
      rental_start_date: form.rental_start_date || null,
      rent_increment_period_months: form.rent_increment_period_months ? parseInt(form.rent_increment_period_months) : 12,
    };

      if (isEditMode) {
        const response = await HttpService.updateRentalOwner(editId, {
          ...payload,
          documents: buildDocumentsFromFiles(form.files),
        });
        if (response.data.success) {
          props.setSnackInfo(response.data.message, "success");
          history.push("/onboarding-rental-service-approval/for-miscpayment");
        }
        return;
      }

      const response = await HttpService.onBoardECOwner(payload);
      if (response.data.success) {
        await deleteDraftAfterSubmit();   // soft-delete draft
        setSubmitted(true);
        props.setSnackInfo(response.data.message, "success");
      }
    } catch (err) {
      props.setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      setSubmitting(false);
    }
  };
  // GST handler ...
  const handleGstToggle = (checked) => {
  set("gst_applicable", checked);
  if (!checked) {
    // Clear GST fields when toggled off
    set("gst_number", "");
    set("gst_percentage", "");
  }
};
// TDS handler ...
const handleTdsToggle = (checked) => {
  set("tds_applicable", checked);
  if (!checked) {
    // Clear TDS field when toggled off
    set("tds_percentage", "");
  }
};

  // ── SUCCESS SCREEN ────────────────────────────────────────────────────────
  if (submitted) {
    const ec = allExperienceCenters.find((e) => e._id === form.experienceCenterId);
    return (
      <Fade in>
        <div className={classes.pageWrap}>
          <div className={[classes.inner, classes.successWrap].join(" ")}>
            <Avatar className={classes.successAvatar}>
              <CheckCircle style={{ fontSize: 40 }} />
            </Avatar>
            <Typography variant="h5" style={{ fontWeight: 700, color: PRIMARY }} gutterBottom>
              Owner onboarded successfully
            </Typography>
            <Typography color="textSecondary" style={{ marginBottom: 24 }}>
              <strong>{form.owner_name}</strong> has been onboarded for{" "}
              <strong>{ec?.name || "—"}</strong>. Profile is pending verification.
            </Typography>
            <Paper className={classes.summaryPaper} variant="outlined">
              {[
                ["Experience Centre", ec?.name         || "—"],
                ["Owner Name",        form.owner_name],
                ["PAN",               form.pan_number.toUpperCase()],
                ["Bank",              `${form.bank.bank_name} · ${form.bank.account_number}`],
                ["Primary Contact",   form.contact_persons[0]?.name || "—"],
                ["Status",            "Pending Verification"],
              ].map(([k, v]) => (
                <div key={k} className={classes.summaryRow}>
                  <Typography variant="body2" color="textSecondary">{k}</Typography>
                  <Typography variant="body2" style={{ fontWeight: 500 }}>{v}</Typography>
                </div>
              ))}
            </Paper>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <Button
                variant="outlined"
                className={classes.outlinedBtn}
                onClick={() => { setForm(INITIAL); setStep(0); setSubmitted(false); setExistingDraft(null); }}
              >
                Onboard another owner
              </Button>
              <Button
                variant="contained"
                className={classes.primaryBtn}
                startIcon={<Receipt />}
                onClick={() => history.push("/ec-payments")}
              >
                Raise EC Payment
              </Button>
            </div>
          </div>
        </div>
      </Fade>
    );
  }

  // ── Derived booleans ──────────────────────────────────────────────────────
  const ifscValid    = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.bank.ifsc_code.toUpperCase());
  const aadhaarValid = /^\d{12}$/.test(form.aadhaar.replace(/\s/g, ""));
  const errCount     = Object.keys(errors).length;

  // ── STEP CONTENT ──────────────────────────────────────────────────────────
  const stepContent = [

    // ── Step 0 ──────────────────────────────────────────────────────────────
    <Fade in key={0}>
      <div>
        <SectionLabel icon={Business} title="Experience Centre"
          subtitle="Link this owner to an Experience Centre" />
        <Grid container spacing={2} style={{ marginBottom: 8 }}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small" error={!!errors.experienceCenterId}>
              <InputLabel>Experience Centre *</InputLabel>
              <Select
                value={form.experienceCenterId}
                label="Experience Centre *"
                onChange={(e) => set("experienceCenterId", e.target.value)}
              >
                {allExperienceCenters.map((ec) => (
                  <MenuItem key={ec._id} value={ec._id}>{ec.name} - {ec.location}</MenuItem>
                ))}
              </Select>
              {errors.experienceCenterId && (
                <FormHelperText>{errors.experienceCenterId}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>

        <Divider style={{ margin: "20px 0" }} />
        <SectionLabel icon={Person} title="Owner Identity"
          subtitle="Legal name as it appears on official documents" />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" variant="outlined"
              label="Owner / Beneficiary Name *"
              placeholder="As per bank records"
              value={form.owner_name}
              onChange={(e) => set("owner_name", e.target.value.toUpperCase())}
              error={!!errors.owner_name}
              helperText={errors.owner_name}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person style={{ fontSize: 18, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" variant="outlined"
              label="Remarks (optional)"
              placeholder="Any notes for the finance team"
              multiline rows={2}
              value={form.remarks}
              onChange={(e) => set("remarks", e.target.value)}
            />
          </Grid>
        </Grid>
      </div>
    </Fade>,

    // ── Step 1 ──────────────────────────────────────────────────────────────
    <Fade in key={1}>
      <div>
        <SectionLabel icon={VerifiedUser} title="Tax & Compliance"
          subtitle="PAN is mandatory. Aadhaar is encrypted at rest." />
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="PAN Number *"
              placeholder="ABCDE1234F"
              value={form.pan_number}
              onChange={(e) => set("pan_number", e.target.value.toUpperCase())}
              error={!!errors.pan_number}
              helperText={errors.pan_number || "10-character PAN"}
              inputProps={{ maxLength: 10, style: { letterSpacing: 2 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AssignmentInd style={{ fontSize: 18, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="Aadhaar Number *"
              placeholder="12 digits"
              value={form.aadhaar}
              onChange={(e) => set("aadhaar", e.target.value.replace(/\D/g, "").slice(0, 12))}
              error={!!errors.aadhaar}
              helperText={errors.aadhaar || "Stored encrypted — never visible after save"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <VisibilityOff style={{ fontSize: 18, color: "#9E9E9E" }} />
                  </InputAdornment>
                ),
                endAdornment: aadhaarValid && (
                  <InputAdornment position="end">
                    <Check style={{ fontSize: 18, color: SUCCESS_COLOR }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12} sm={6}>
            <FileUploadCard
              label="Aadhaar Card" required
              error={errors.aadhaar_doc}
              fieldKey="aadhaar_doc"
              file={form.files.aadhaar_doc}
              onChange={handleFileUpload}
              uploading={uploadingFile}
              uploadProgress={uploadProgress.aadhaar_doc || 0}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FileUploadCard
              label="PAN Card" required
              error={errors.pan_doc}
              fieldKey="pan_doc"
              file={form.files.pan_doc}
              onChange={handleFileUpload}
              uploading={uploadingFile}
              uploadProgress={uploadProgress.pan_doc || 0}
            />
          </Grid>
        </Grid>

        <Divider style={{ marginBottom: 16 }} />

        <div className={classes.toggleBox}>
          <FormControlLabel
            control={
              <Switch
                checked={form.gst_applicable}
                color="primary"
                onChange={(e) => handleGstToggle(e.target.checked)}
              />
            }
            label={
              <div>
                <Typography variant="body2" style={{ fontWeight: 500 }}>GST Applicable</Typography>
                <Typography variant="caption" color="textSecondary">Toggle if owner is GST registered</Typography>
              </div>
            }
          />
          <Collapse in={form.gst_applicable}>
            <div style={{ marginTop: 16 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="GST Number *"
                    placeholder="27AAPFU0939F1ZV"
                    value={form.gst_number}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      set("gst_number", value);
                      // Real-time validation
                      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                      if (value && !gstRegex.test(value)) {
                        setErrors(prev => ({ ...prev, gst_number: "Invalid GST format (e.g. 22AAAAA0000A1Z5)" }));
                      } else {
                        setErrors(prev => { const n = { ...prev }; delete n.gst_number; return n; });
                      }
                    }}
                    error={!!errors.gst_number}
                    helperText={errors.gst_number || "15-character GST number (e.g. 22AAAAA0000A1Z5)"}
                    inputProps={{
                      maxLength: 15,
                      style: { letterSpacing: 1 }
                    }}
                    InputProps={{
                      endAdornment: form.gst_number && /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(form.gst_number) && (
                        <InputAdornment position="end">
                          <Check style={{ fontSize: 18, color: SUCCESS_COLOR }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="GST Percentage *"
                    type="number"
                    inputProps={{ min: 0, max: 100, step: 0.5 }}
                    value={form.gst_percentage}
                    onChange={(e) => {
                      const value = e.target.value;
                      set("gst_percentage", value);
                      if (value && (parseFloat(value) < 0 || parseFloat(value) > 100)) {
                        setErrors(prev => ({ ...prev, gst_percentage: "GST percentage must be between 0 and 100" }));
                      } else {
                        setErrors(prev => { const n = { ...prev }; delete n.gst_percentage; return n; });
                      }
                    }}
                    error={!!errors.gst_percentage}
                    helperText={errors.gst_percentage || "e.g. 18 for 18% GST"}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">%</InputAdornment>,
                      endAdornment: form.gst_percentage && parseFloat(form.gst_percentage) >= 0 && parseFloat(form.gst_percentage) <= 100 && (
                        <InputAdornment position="end">
                          <Check style={{ fontSize: 18, color: SUCCESS_COLOR }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FileUploadCard
                    label="GST Certificate" required
                    error={errors.gst_doc}
                    fieldKey="gst_doc"
                    file={form.files.gst_doc}
                    onChange={handleFileUpload}
                    uploading={uploadingFile}
                    uploadProgress={uploadProgress.gst_doc || 0}
                  />
                </Grid>
              </Grid>
            </div>
          </Collapse>
        </div>

        <div className={classes.toggleBox} style={{ marginBottom: 0 }}>
          <FormControlLabel
            control={
              <Switch
                checked={form.tds_applicable}
                color="primary"
                onChange={(e) => handleTdsToggle(e.target.checked)}
              />
            }
            label={
              <div>
                <Typography variant="body2" style={{ fontWeight: 500 }}>TDS Applicable</Typography>
                <Typography variant="caption" color="textSecondary">Enable for TDS deduction on rent payments</Typography>
              </div>
            }
          />
          <Collapse in={form.tds_applicable}>
            <div style={{ marginTop: 16 }}>
              <TextField
                size="small"
                variant="outlined"
                label="TDS Percentage *"
                type="number"
                inputProps={{ min: 0, max: 100, step: 0.5 }}
                value={form.tds_percentage}
                onChange={(e) => {
                  const value = e.target.value;
                  set("tds_percentage", value);
                  if (value && (parseFloat(value) < 0 || parseFloat(value) > 100)) {
                    setErrors(prev => ({ ...prev, tds_percentage: "TDS percentage must be between 0 and 100" }));
                  } else {
                    setErrors(prev => { const n = { ...prev }; delete n.tds_percentage; return n; });
                  }
                }}
                error={!!errors.tds_percentage}
                helperText={errors.tds_percentage || "e.g. 2 for 2% TDS (Section 194-I)"}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                style={{ width: 200 }}
              />
              <div style={{ marginTop: 16, maxWidth: 340 }}>
                <FileUploadCard
                  label="TDS Declaration Form"
                  hint="Optional — Form 15G / 15H or TDS exemption certificate"
                  fieldKey="tds_doc"
                  file={form.files.tds_doc}
                  onChange={handleFileUpload}
                  uploading={uploadingFile}
                  uploadProgress={uploadProgress.tds_doc || 0}
                />
              </div>
            </div>
          </Collapse>

        </div>
      </div>
    </Fade>,

    // ── Step 2 ──────────────────────────────────────────────────────────────
    <Fade in key={2}>
      <div>
        <SectionLabel icon={AccountBalance} title="Bank Account Details"
          subtitle="Used for rent payment transfers — must match owner's records" />
        <Alert severity="info" className={classes.infoAlert} icon={<Info style={{ fontSize: 18 }} />}>
          Enter details exactly as they appear on the cancelled cheque or passbook.
        </Alert>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="Account Holder Name *"
              placeholder="As per bank records"
              value={form.bank.account_name}
              onChange={(e) => setBank("account_name", e.target.value.toUpperCase())}
              error={!!errors.account_name} helperText={errors.account_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="Account Number *"
              value={form.bank.account_number}
              onChange={(e) => setBank("account_number", e.target.value.replace(/\D/g, ""))}
              error={!!errors.account_number} helperText={errors.account_number}
              inputProps={{ style: { letterSpacing: 2 } }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="Bank Name *"
              placeholder="e.g. State Bank of India"
              value={form.bank.bank_name}
              onChange={(e) => setBank("bank_name", e.target.value.toUpperCase())}
              error={!!errors.bank_name} helperText={errors.bank_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="Branch Name *"
              value={form.bank.branch_name}
              onChange={(e) => setBank("branch_name", e.target.value.toUpperCase())}
              error={!!errors.branch_name} helperText={errors.branch_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" variant="outlined" label="IFSC Code *"
              placeholder="SBIN0001234"
              value={form.bank.ifsc_code}
              onChange={(e) => setBank("ifsc_code", e.target.value.toUpperCase())}
              error={!!errors.ifsc_code}
              helperText={errors.ifsc_code || "11-character IFSC code"}
              inputProps={{ maxLength: 11, style: { letterSpacing: 2 } }}
              InputProps={{
                endAdornment: ifscValid && (
                  <InputAdornment position="end">
                    <Check style={{ fontSize: 18, color: SUCCESS_COLOR }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Account Type</InputLabel>
              <Select
                value={form.bank.account_type}
                label="Account Type"
                onChange={(e) => setBank("account_type", e.target.value)}
              >
                {ACCOUNT_TYPES.map((t) => (
                  <MenuItem key={t} value={t}>{t.toUpperCase()}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FileUploadCard
              label="Cancelled Cheque / Passbook" required
              error={errors.cheque_doc}
              fieldKey="cheque_doc"
              file={form.files.cheque_doc}
              onChange={handleFileUpload}
              uploading={uploadingFile}
              uploadProgress={uploadProgress.cheque_doc || 0}
            />
          </Grid>
        </Grid>
      </div>
    </Fade>,

    // ── Step 3 ──────────────────────────────────────────────────────────────
    <Fade in key={3}>
      <div>
        <SectionLabel icon={Home} title="Property Address"
          subtitle="Physical address of the rented premises" />
        <Grid container spacing={2} style={{ marginBottom: 8 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" variant="outlined" label="Street Address Line 1 *"
              placeholder="Building name, street"
              value={form.address.line1}
              onChange={(e) => setAddr("line1", e.target.value)}
              error={!!errors.addr_line1} helperText={errors.addr_line1}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" variant="outlined" label="Line 2 (optional)"
              placeholder="Area, landmark"
              value={form.address.line2}
              onChange={(e) => setAddr("line2", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth size="small" variant="outlined" label="City *"
              value={form.address.city}
              onChange={(e) => setAddr("city", e.target.value)}
              error={!!errors.addr_city} helperText={errors.addr_city}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth variant="outlined" size="small" error={!!errors.addr_state}>
              <InputLabel>State *</InputLabel>
              <Select
                value={form.address.state} label="State *"
                onChange={(e) => setAddr("state", e.target.value)}
              >
                {INDIAN_STATES.map((s) => (
                  <MenuItem key={s} value={s}>{s}</MenuItem>
                ))}
              </Select>
              {errors.addr_state && <FormHelperText>{errors.addr_state}</FormHelperText>}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth size="small" variant="outlined" label="Pincode *"
              inputProps={{ maxLength: 6 }}
              value={form.address.pincode}
              onChange={(e) => setAddr("pincode", e.target.value.replace(/\D/g, "").slice(0, 6))}
              error={!!errors.addr_pincode} helperText={errors.addr_pincode}
            />
          </Grid>
        </Grid>

        <Divider style={{ margin: "20px 0" }} />
    <SectionLabel icon={Receipt} title="Rent Payment Terms"
      subtitle="Configure rent amount, due date and penalty rules" />

    <div className={classes.rentTermsBox}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Monthly Rent Amount *"
            type="number"
            inputProps={{ min: 0, step: 0.01 }}
            placeholder="e.g. 25000"
            value={form.rent_amount}
            onChange={(e) => set("rent_amount", e.target.value)}
            error={!!errors.rent_amount}
            helperText={errors.rent_amount || "Monthly rent amount (must be greater than 0)"}
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Rental Start Date *"
            type="date"
            value={form.rental_start_date}
            onChange={(e) => set("rental_start_date", e.target.value)}
            error={!!errors.rental_start_date}
            helperText={errors.rental_start_date || "Date when rent started"}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Rent Increment Period (Months)"
            type="number"
            inputProps={{ min: 1, max: 60 }}
            placeholder="e.g. 12"
            value={form.rent_increment_period_months}
            onChange={(e) => set("rent_increment_period_months", e.target.value)}
            helperText="Months after which rent increases (default: 12)"
            InputProps={{
              endAdornment: <InputAdornment position="end">months</InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Rent Due Day *"
            type="number"
            inputProps={{ min: 1, max: 31 }}
            placeholder="e.g. 10"
            value={form.due_day}
            onChange={(e) => set("due_day", e.target.value)}
            error={!!errors.due_day}
            helperText={errors.due_day || "Day of month (1–31)"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Max Payment Day *"
            type="number"
            inputProps={{ min: 1, max: 31 }}
            placeholder="e.g. 14"
            value={form.max_payment_day}
            onChange={(e) => set("max_payment_day", e.target.value)}
            error={!!errors.max_payment_day}
            helperText={errors.max_payment_day || "Grace period last day"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Penalty per Day *"
            type="number"
            inputProps={{ min: 0 }}
            value={form.penalty_per_day}
            onChange={(e) => set("penalty_per_day", e.target.value)}
            error={!!errors.penalty_per_day}
            helperText={errors.penalty_per_day || "Charged after max payment day"}
            InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
          />
        </Grid>
      </Grid>

          {form.due_day && form.max_payment_day && form.penalty_per_day && form.rent_amount && parseFloat(form.rent_amount) > 0 && (
            <div className={classes.rentPreview}>
              <Info style={{ fontSize: 16, color: PRIMARY_LIGHT }} />
              <Typography variant="caption" color="textSecondary">
                Monthly Rent: <strong>₹{parseFloat(form.rent_amount).toLocaleString()}</strong> ·
                Due on the <strong>{form.due_day}th</strong> every month.
                Penalty of <strong>₹{form.penalty_per_day}/day</strong> applies after the{" "}
                <strong>{form.max_payment_day}th</strong>.
              </Typography>
            </div>
          )}
        </div>

        <Divider style={{ margin: "20px 0" }} />
        <SectionLabel icon={Description} title="Rental Agreement Details"
          subtitle="Agreement dates and yearly increment terms" />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Agreement Effective Date *"
              type="date"
              value={form.agreement_effective_date}
              onChange={(e) => set("agreement_effective_date", e.target.value)}
              error={!!errors.agreement_effective_date}
              helperText={errors.agreement_effective_date || "Start date of the rental agreement"}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Agreement Expiry Date *"
              type="date"
              value={form.agreement_expiry_date}
              onChange={(e) => set("agreement_expiry_date", e.target.value)}
              error={!!errors.agreement_expiry_date}
              helperText={errors.agreement_expiry_date || "End date of the rental agreement"}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Increment Type</InputLabel>
              <Select
                value={form.yearly_increment_type || "percentage"}
                label="Increment Type"
                onChange={(e) => set("yearly_increment_type", e.target.value)}
              >
                <MenuItem value="percentage">Percentage (%)</MenuItem>
                <MenuItem value="fixed">Fixed Amount (₹)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label={`Yearly Increment ${form.yearly_increment_type === "percentage" ? "(%)" : "(₹)"}`}
              type="number"
              inputProps={{ min: 0, step: form.yearly_increment_type === "percentage" ? 0.5 : 1 }}
              placeholder={form.yearly_increment_type === "percentage" ? "e.g. 10" : "e.g. 5000"}
              value={form.yearly_increment_value}
              onChange={(e) => set("yearly_increment_value", e.target.value)}
              error={!!errors.yearly_increment_value}
              helperText={errors.yearly_increment_value ||
                form.yearly_increment_type === "percentage"
                ? "Percentage increase per year (e.g. 10%)"
                : "Fixed amount increase per year"}
              InputProps={{
                endAdornment: form.yearly_increment_type === "percentage" && (
                  <InputAdornment position="end">%</InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            {form.rent_amount && form.yearly_increment_value && form.yearly_increment_type && (
              <Paper style={{ padding: theme.spacing(2), backgroundColor: "#f8f9fa", textAlign: "center" }}>
                <Typography variant="caption" color="textSecondary">Projected Next Year Rent</Typography>
                <Typography variant="body1" style={{ fontWeight: 700, color: PRIMARY }}>
                  ₹{(() => {
                    const currentRent = parseFloat(form.rent_amount) || 0;
                    const incrementValue = parseFloat(form.yearly_increment_value) || 0;
                    let projectedRent = currentRent;
                    if (form.yearly_increment_type === "percentage") {
                      projectedRent = currentRent + (currentRent * incrementValue / 100);
                    } else {
                      projectedRent = currentRent + incrementValue;
                    }
                    return projectedRent.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    });
                  })()}
                </Typography>
              </Paper>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <FileUploadCard
              label="Rental Agreement" required
              error={errors.agreement_doc}
              fieldKey="agreement_doc"
              file={form.files.agreement_doc}
              onChange={handleFileUpload}
              uploading={uploadingFile}
              uploadProgress={uploadProgress.agreement_doc || 0}
            />
          </Grid>
        </Grid>
      </div>
    </Fade>,

    // ── Step 4 ──────────────────────────────────────────────────────────────
    <Fade in key={4}>
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <SectionLabel
            icon={Contacts}
            title="Contact Persons"
            subtitle={`1 required · up to 4 total (${form.contact_persons.length}/4 added)`}
          />
          {form.contact_persons.length < 4 && (
            <Button
              variant="outlined" startIcon={<Add />} size="small"
              onClick={addContact}
              style={{ borderColor: BORDER, color: PRIMARY, borderRadius: 8,
                textTransform: "none", whiteSpace: "nowrap", flexShrink: 0 }}
            >
              Add person
            </Button>
          )}
        </div>

        <Chip
          label="Contact Person 1 is mandatory"
          size="small"
          className={classes.mandatoryBadgeChip}
        />

        {form.contact_persons.map((cp, i) => (
          <ContactPersonCard
            key={i}
            index={i}
            person={cp}
            isMandatory={i === 0}
            cpErrors={i === 0
              ? {
                  name:            errors.cp0_name,
                  primary_mobile:  errors.cp0_mobile,
                  email:           errors.cp0_email,
                  whatsapp_number: errors.cp0_whatsapp,
                }
              : { primary_mobile: errors[`cp${i}_mobile`] }
            }
            onChange={updContact}
            onRemove={remContact}
          />
        ))}

        <Divider style={{ margin: "20px 0" }} />

        <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
          Other Documents{" "}
          <Typography component="span" variant="caption" color="textSecondary">
            (optional · up to 5)
          </Typography>
        </Typography>

        {form.files.other_docs.map((f, i) => (
          <div key={i} className={classes.otherDocRow}>
            <CloudUpload style={{ fontSize: 18, color: PRIMARY_LIGHT }} />
            <Typography variant="body2"
              style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {f.name}
            </Typography>
            <Typography variant="caption" style={{ color: "#4caf50", marginRight: 8 }}>
              ✓ Uploaded
            </Typography>
            <IconButton size="small" onClick={() => remOtherFile(i)} style={{ color: "#D32F2F" }}>
              <Delete style={{ fontSize: 16 }} />
            </IconButton>
          </div>
        ))}
        {form.files.other_docs.length < 5 && (
          <Button
            variant="outlined"
            component="label"
            startIcon={<Add />}
            size="small"
            className={classes.addDocBtn}
            disabled={uploadingFile}
          >
            Add more documents
            <input
              type="file"
              style={{ display: "none" }}
              multiple
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              onChange={handleOtherDocsUpload}
              disabled={uploadingFile}
            />
          </Button>
        )}

        <div className={classes.uploadSummary}>
          <span className={classes.summaryLabel}>Document Upload Summary</span>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {[
              ["Aadhaar",   form.files.aadhaar_doc],
              ["PAN",       form.files.pan_doc],
              ["GST",       form.files.gst_doc],
              ["TDS Decl.", form.files.tds_doc],
              ["Cheque",    form.files.cheque_doc],
              ["Agreement", form.files.agreement_doc],
            ].map(([lbl, f]) => (
              <Chip
                key={lbl}
                label={lbl}
                size="small"
                icon={f ? <Check style={{ fontSize: 14 }} /> : undefined}
                className={f ? classes.chipUploaded : classes.chipPending}
              />
            ))}
            {form.files.other_docs.length > 0 && (
              <Chip
                label={`+${form.files.other_docs.length} other`}
                size="small"
                className={classes.chipOther}
              />
            )}
          </div>
        </div>
      </div>
    </Fade>,
  ];

  // ── RENDER ────────────────────────────────────────────────────────────────
  if (loadingEditRecord) {
    return (
      <div className={classes.pageWrap}>
        <div className={classes.inner} style={{ textAlign: "center", paddingTop: 80 }}>
          <CircularProgress style={{ color: PRIMARY_LIGHT }} />
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
            Loading owner record…
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.pageWrap}>
      <div className={classes.inner}>

        {/* ── Onboarding type selector (hidden while editing — type is fixed) ── */}
        {!isEditMode && (
        <div className={classes.typeSelectorWrap}>
          <span className={classes.typeSelectorLabel}>Onboarding Type</span>
          <div className={classes.typeToggleRow}>
            {[
              { value: "rental",           label: "Rental Owner",      Icon: Home },
              { value: "service_provider", label: "Service Provider",  Icon: Build },
            ].map(({ value, label, Icon }) => {
              const active = onboardingType === value;
              return (
                <div
                  key={value}
                  className={[classes.typeToggleBtn, active ? classes.typeToggleBtnActive : ""].join(" ")}
                  onClick={() => setOnboardingType(value)}
                >
                  <div className={[
                    classes.typeToggleIcon,
                    active ? classes.typeToggleIconActive : classes.typeToggleIconInactive,
                  ].join(" ")}>
                    <Icon style={{ fontSize: 16, color: active ? "#fff" : "#7A95B5" }} />
                  </div>
                  <Typography variant="body2" style={{
                    fontWeight: active ? 700 : 500,
                    color: active ? PRIMARY : undefined,
                  }}>
                    {label}
                  </Typography>
                  {active && (
                    <Check style={{ fontSize: 16, color: PRIMARY_LIGHT, marginLeft: 4 }} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
        )}

        {/* ── Service Provider form (mounted inline when type = service_provider) ── */}
        {onboardingType === "service_provider" && (
          <Fade in>
            <div>
              <div className={classes.headerWrap}>
                <div className={classes.headerRow}>
                  <Avatar className={classes.headerAvatar}>
                    <Build style={{ fontSize: 18 }} />
                  </Avatar>
                  <Typography variant="h5" className={classes.headerTitle}>
                    {isEditMode ? "Edit Service Provider" : "Service Provider Onboarding"}
                  </Typography>
                </div>
                <Typography variant="body2" className={classes.headerSub}>
                  {isEditMode
                    ? "Editing this record will re-submit it for approval from level 1"
                    : "Register a new service provider for an Experience Centre"}
                </Typography>
              </div>
              <ServiceProviderOnboarding
                allExperienceCenters={allExperienceCenters}
                setLoading={props.setLoading}
                setSnackInfo={props.setSnackInfo}
                editId={isEditMode ? editId : null}
              />
            </div>
          </Fade>
        )}

        {/* ── Rental Owner form (existing stepper) ── */}
        {onboardingType === "rental" && (<>

        {/* Header */}
        <div className={classes.headerWrap}>
          <div className={classes.headerRow}>
            <Avatar className={classes.headerAvatar}>
              <Home style={{ fontSize: 18 }} />
            </Avatar>
            <Typography variant="h5" className={classes.headerTitle}>
              {isEditMode ? "Edit Rental Owner" : "Rental Owner Onboarding"}
            </Typography>
          </div>
          <Typography variant="body2" className={classes.headerSub}>
            {isEditMode
              ? "Editing this record will re-submit it for approval from level 1"
              : "Register a new property owner for an Experience Centre"}
          </Typography>
        </div>

        {/* ── Draft Resume Banner ── */}
        {!isEditMode && showDraftBanner && existingDraft && (
          <Fade in>
            <div className={classes.draftBanner}>
              <div className={classes.draftBannerLeft}>
                <Restore className={classes.draftBannerIcon} />
                <div>
                  <Typography variant="body2" style={{ fontWeight: 600, color: WARN_COLOR }}>
                    You have an unsaved draft
                  </Typography>
                  <Typography variant="caption" style={{ color: WARN_COLOR, opacity: 0.8 }}>
                    {existingDraft.formData?.owner_name
                      ? `Owner: ${existingDraft.formData.owner_name}`
                      : "Saved earlier"}
                    {existingDraft.updatedAt
                      ? ` · ${new Date(existingDraft.updatedAt).toLocaleDateString("en-IN", {
                          day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
                        })}`
                      : ""}
                  </Typography>
                </div>
              </div>
              <div className={classes.draftBannerActions}>
                <Button
                  variant="outlined"
                  size="small"
                  className={classes.discardBtn}
                  onClick={handleDiscardDraft}
                >
                  Discard
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  className={classes.resumeBtn}
                  startIcon={<Restore style={{ fontSize: 16 }} />}
                  onClick={handleResumeDraft}
                >
                  Resume draft
                </Button>
                <IconButton size="small" onClick={() => setShowDraftBanner(false)}
                  style={{ color: WARN_COLOR, padding: 4 }}>
                  <Close style={{ fontSize: 16 }} />
                </IconButton>
              </div>
            </div>
          </Fade>
        )}

        {/* Progress bar */}
        <div className={classes.progressWrap}>
          <div className={classes.progressTopRow}>
            <Typography variant="caption" color="textSecondary">
              Step {step + 1} of {STEPS.length}
            </Typography>
            <Typography variant="caption" style={{ fontWeight: 600, color: PRIMARY }}>
              {Math.round((step / STEPS.length) * 100)}% complete
            </Typography>
          </div>
          <LinearProgress
            variant="determinate"
            value={Math.round((step / STEPS.length) * 100)}
            className={classes.progressBar}
          />
        </div>

        {/* Stepper */}
        <div className={classes.stepperScroll}>
          <Stepper activeStep={step} alternativeLabel connector={<ECConnector />} className={classes.stepper}>
            {STEPS.map((s, i) => (
              <Step key={s.label} completed={i < step}>
                <StepLabel
                  StepIconComponent={ECStepIcon}
                  classes={{ active: classes.stepLabelActive, completed: classes.stepLabelCompleted }}
                >
                  <Typography variant="caption" style={{
                    fontWeight: i === step ? 600 : 400,
                    color: i === step ? PRIMARY : undefined,
                    fontSize: 11.5,
                  }}>
                    {s.label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>

        {/* Step card */}
        <Paper elevation={0} className={classes.stepCard}>
          <div className={classes.cardTopBand}>
            <div>
              <span className={classes.stepOverline}>Step {step + 1} of {STEPS.length}</span>
              <Typography variant="h6" className={classes.stepTitle}>
                {STEPS[step].label}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {STEPS[step].sub}
              </Typography>
            </div>
            {touched && errCount > 0 && (
              <Alert severity="error" style={{ padding: "2px 12px", borderRadius: 6, fontSize: 12 }}>
                {errCount} field{errCount > 1 ? "s" : ""} need attention
              </Alert>
            )}
          </div>
          {stepContent[step]}
        </Paper>

        {/* Navigation */}
        <div className={classes.navRow}>

          {/* Left: Back + Save Draft */}
          <div className={classes.navLeft}>
            <Button
              variant="outlined" startIcon={<ArrowBack />}
              onClick={handleBack} disabled={step === 0}
              className={classes.backBtn}
            >
              Back
            </Button>
            {!isEditMode && (
              <Button
                variant="outlined"
                startIcon={
                  savingDraft
                    ? <CircularProgress size={14} style={{ color: WARN_COLOR }} />
                    : <Save style={{ fontSize: 16 }} />
                }
                onClick={handleSaveDraft}
                disabled={savingDraft}
                className={classes.saveDraftBtn}
                size="small"
              >
                {savingDraft ? "Saving…" : draftSavedAt ? `Saved ${draftSavedAt}` : "Save draft"}
              </Button>
            )}
          </div>

          {/* Centre: dot pagination */}
          <div className={classes.dotRow}>
            {STEPS.map((_, i) => (
              <div
                key={i}
                className={classes.dot}
                style={{
                  width: i === step ? 20 : 8,
                  backgroundColor: i < step ? PRIMARY : i === step ? PRIMARY_LIGHT : "#D0DCF0",
                }}
              />
            ))}
          </div>

          {/* Right: Continue / Submit */}
          <div className={classes.navRight}>
            {step < STEPS.length - 1 ? (
              <Button
                variant="outlined" endIcon={<ArrowForward />}
                onClick={handleNext} className={classes.nextBtn}
              >
                Continue
              </Button>
            ) : (
              <Button
                variant="contained" onClick={handleSubmit}
                disabled={submitting} className={classes.submitBtn}
                startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : <Check />}
              >
                {submitting ? "Saving…" : isEditMode ? "Save Changes" : "Submit & Onboard"}
              </Button>
            )}
          </div>
        </div>
      </>)}
    </div>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(RentalOwnerOnboarding);